import React, { useEffect, useRef, useState } from 'react'
import { Link } from "react-router-dom";
// images
import LogoTopLeft from "../../images/LogoTopLeft.png";
import TopIcon from "../../images/TopIcon.png";
import FacebookIcon from "../../images/facebook_icon.png";
import InstagramIcon from "../../images/instagram_icon.png";
import TwitterIcon from "../../images/twitter_idcon.png";
import ShoppingCartIcon from "../../images/ShoppingCartIcon.png";
import contents_somemono from "../../images/contents_somemono.png";
import ContentsButton from "../../images/contents_button.png";
import contents_standh from "../../images/contents_standh.png";
import ContentsDiamond from "../../images/contents-diamond.png";
import ContentsMiddleShip from "../../images/ContentsMiddleShip.png";
import top_middle_name from "../../images/top_middle_name.png";
import Newsimg_01 from "../../images/news_01.png";
import Newsimg_02 from "../../images/news_02.png";
import Newsimg_03 from "../../images/news_03.png";
import ContentsBackgroundImg from "../../images/ContentsBackgroundImg.png";
import footer_backgrond from "../../images/footer_backgrond.png";

// コンポーネントのインポート
import SliderSlide from '../SliderSlide';
import SliderFade from '../SliderFade';

import KondoHeader from '../Header';
import KondoFooter from '../Footer';
import imgPreload from '../imgPreload';

// animation
import {motion} from "framer-motion"
import InitialTransition from "../../utils/blackbox" 
import OrgTransition from "../../utils/OriginalFade"
import ContactForm from '../ContactForm';

// pararax
<script src="https://cdn.jsdelivr.net/gh/dixonandmoe/rellax@master/rellax.min.js"></script>

const PageKondou = () => {

    const [isOpenMenu, setIsOpenMenu] = React.useState(false);

    const [count, setCount] = useState(0);
    useEffect(() => {
        console.log("Hello hooks");
        imgPreload();
    }, []);

    useEffect(() => {
        console.log("Hello hooks");
    }, [count]);

    const handleOnClick = () => {
        setCount(count + 1);
        if(!isOpenMenu){
            console.log(isOpenMenu);
            setIsOpenMenu(true);
        }else{
            console.log(isOpenMenu);
            setIsOpenMenu(false);
        }
        var windowWidth = window.innerWidth;
        var windowSm = 0;
        if (windowWidth <= windowSm) {
        } else {
            document.getElementById('target')?.classList.toggle('active');
            document.getElementById('g-nav')?.classList.toggle('panelactive');
        }
        console.log("count = ", count);
    };



    return (
            <div id="PageKondou">
                <KondoHeader />
                    <motion.div
                        animate={{
                            y: 0,
                            opacity: 1
                        }}
                        initial={{
                            y: 0,
                            opacity: 0
                        }}
                        exit={{
                            y: 100,
                            opacity: 0
                        }}
                        transition={{
                            duration: 0.4,
                            ease: "easeOut",
                        }}
                    >
                    <main>
                        <div className='slider-wrap'>
                            <SliderFade />
                        </div>
                        <section className='top-slider'>   
                            <aside className='background-opacity'></aside>
                            <motion.div
                                drag="x"
                                dragConstraints={{ left: -1000, right: 100 }}
                            >
                                <div>
                                    <h1>染は心の美</h1>
                                    <h2>技の冴えは伝統</h2>
                                </div>
                            </motion.div>
                        </section>
                        <section className='top-feed'>
                            <div>
                                <h2>TOPIC</h2>
                                <h3>2023.1.1</h3>
                                <p>本年も格別のお引き立てを賜りますよう、どうぞよろしくお願い致します。</p>
                            </div>
                        </section>
                        <section className="contents">
                            <div>
                                <img src={contents_somemono} alt="時代に染まらない染物" />
                                <h2>時代に染まらない染物</h2>
                                <p>
                                    創業明治31年。染め一筋に歩んで120年の歳月。<br/>
                                    以来、いつも変わらぬものは、生地や染料など質の高い素材を吟味する鋭い目。<br/>
                                    そして、手染めの温もりを愛で伝えようとする職人の手。私たち近藤染工場は、長年培ってまいりました「目と手」に、たゆまぬ精進と努力を積み重ね、伝統の技に斬新な感覚と冴えをプラスして、お客様のあらゆるニーズにお答えします。
                                </p>                    
                            </div>
                        </section>
                        <section className="contents-02">
                            <article className='back-rectangle'>
                                <div>
                                    <h2>
                                        {/* 漁師の心意気<br/>
                                        大漁安全祈願 */}
                                        <img src={top_middle_name} alt="top_middle_name" />
                                    </h2>
                                    <h1>大漁旗</h1>
                                </div>
                            </article>
                            <article>
                                <img src={ContentsMiddleShip} alt='制作のご依頼'/>
                            </article>
                            <article>
                                <a href='http://www.kondo-some.co.jp/contact/'>
                                    <button><span>作成ご依頼方法</span></button>
                                </a>
                                <a href='http://www.kondo-some.co.jp/lineup/'>
                                    <button><span>参考価格</span></button>
                                </a>
                            </article>
                        </section>
                        <section className="contents-03">
                            <div>
                                <h1>CATEGORY</h1>
                                <h2>商品カテゴリー</h2>
                                <ul>
                                    <div className='diamond'>
                                        <a href='http://www.kondo-some.co.jp/lineup/tairyou.html'>
                                            <aside>
                                                <li id="test"></li>
                                                <p className='p-1column'>大漁旗</p>
                                            </aside>
                                        </a>
                                        <a href='http://www.kondo-some.co.jp/lineup/etc.html'>
                                            <aside>
                                                <li></li>
                                                <p className='p-3column'>国旗・社旗<br/>安全旗・会旗<br/>その他旗</p>
                                            </aside>
                                        </a>
                                        <a href="http://www.kondo-some.co.jp/lineup/jinjya.html">
                                            <aside>
                                                <li></li>
                                                <p className='p-2column'>神社・仏閣用<br/>のぼり・幕</p>
                                            </aside>
                                        </a>
                                    </div>
                                    <div className='diamond'>
                                        <a href='http://www.kondo-some.co.jp/lineup/noren.html'>
                                            <aside>
                                                <li></li>
                                                <p className='p-2column'>のれん<br/>日除けのれん</p>
                                            </aside>
                                        </a>
                                        <a href="http://www.kondo-some.co.jp/lineup/kaiki.html">
                                            <aside>
                                                <li></li>
                                                <p className='p-2column' style={{top: "33px"}}>帆前掛け<br/>風呂敷</p>
                                            </aside>
                                        </a>
                                        <a href="https://kondo.shop-pro.jp/">
                                            <aside>
                                                <li></li>
                                                <p className='p-2column' style={{top: "28px"}}>手ぬぐい<br/>タオル他</p>
                                            </aside>
                                        </a>
                                    </div>
                                    <div className='diamond'>
                                        <a href='http://www.kondo-some.co.jp/lineup/hanten.html'>
                                            <aside>
                                                <li></li>
                                                <p className='p-2column' style={{top: "28px"}}>はんてん<br/>祭小物</p>
                                            </aside>
                                        </a>
                                        <a href="http://www.kondo-some.co.jp/lineup/nobori.html">
                                            <aside>
                                                <li></li>
                                                <p className='p-1column'>のぼり</p>
                                            </aside>
                                        </a>
                                        <a href="https://kondo.shop-pro.jp/">
                                            <aside>
                                                <li></li>
                                                <p className='p-2column' style={{top: "15px"}}>節句祝い<br/>各種御祝い</p>
                                            </aside>
                                        </a>
                                    </div>
                                    <img src={ContentsDiamond} alt='Background iamge' className='contents-diamond-bkimg'/>
                                </ul>
                                <a href='http://kondo.shop-pro.jp/'>
                                    <img src={ContentsButton} alt='オンラインショップ' />
                                </a>
                            </div>
                        </section>
                        <section className="contents-04">
                            <div>
                                <img src={contents_standh} alt="時代に染まらない染物" />
                                <h2>新しい染物のかたち</h2>
                                <p>
                                    <img src={TopIcon} alt="近藤染工場アイコン" /><br/> 
                                    近藤染工場で作っているのは伝統工芸品なのではなく、はっぴやのれんなどの日用品。日用品は時代とともに変化していくもの。エコバッグや前掛け、キャンプ・アウトドア用品といった現代的な日用品にもチャレンジしています。<br/>
                                    ありふれた日用品のなかに、100年以上の伝統を背負った一流の仕事を感じていただければ幸いです。<br/>
                                    アイデアがございましたらご一緒にお作りしますので是非お持ち込みください。
                                </p>                    
                            </div>
                            
                        </section>
                        <section className='contents-05'>
                            <SliderSlide />
                        </section>
                        <section className='news'>
                            <article>
                                <h1>NEWS</h1>
                                <h2>お知らせ</h2>
                                <ul>
                                    <a href="http://www.kondo-some.co.jp/blog/?p=1217">       
                                        <li>
                                            <img src={Newsimg_03} alt='ニュースのサムネ画像' />
                                            <aside>
                                                <h3>2023.01.30</h3>
                                                <p>2月の営業について</p>
                                            </aside>
                                        </li>
                                    </a>
                                    <a href="http://www.kondo-some.co.jp/blog/?p=1213">
                                        <li>
                                            <img src={Newsimg_01} alt='ニュースのサムネ画像' />
                                            <aside>
                                                <h3>2023.01.13</h3>
                                                <p>1月の営業について</p>
                                            </aside>
                                        </li>
                                    </a>
                                    <a href="http://www.kondo-some.co.jp/blog/?p=1202">
                                        <li>
                                            <img src={Newsimg_02} alt='ニュースのサムネ画像' />
                                            <aside>
                                                <h3>2022.12.02</h3>
                                                <p>12月の営業について</p>
                                            </aside>
                                        </li>
                                    </a>
                                </ul>
                                <Link to="/news">
                                    <button>お知らせ一覧を見る</button>
                                </Link>
                            </article>
                        </section>
                        <section className='contents-para'>
                            <article>
                                <div className="parallax-bg"></div>
                                <div className="scrollbox">
                                    <h1>
                                        SPRIT<br/>
                                        染の心
                                    </h1>
                                    <p>
                                        近藤染工場の伝統と染の心を通じて<br/>
                                        彩ある日常の生活を過ごしていただければ幸いです。
                                    </p>
                                    <Link to="/article">
                                        <button>「染の心」を見る</button>
                                    </Link>
                                </div>
                            </article>
                        </section>
                        <section className='contact'>
                            <Link to="/contact">
                                <button>お問い合わせはこちらから</button>
                            </Link>
                        </section>
                    </main>
                    <KondoFooter />
                </motion.div>
            </div>
    )
}

export default PageKondou;
